





















import {
  Vue, Component, Prop
} from "@/shared/vuepack";
import moment from "moment-timezone";
import * as transferScheduleUtility from "@/employee/Utilities/TransferScheduleUtility";
import { HsabExpenseResponse, RelationshipType, TransferSchedule } from "@/shared/types";

@Component({
  components: { }
})
export default class AccountHolderExpenseSchedule extends Vue {
  copied = false;

  @Prop()
  expense: HsabExpenseResponse;

  @Prop()
  schedule: TransferSchedule;

  @Prop()
  username: string;

  get formattedStartDate () {
    return moment(this.schedule.scheduleStartDate).format("MMM DD, YYYY");
  }

  get formattedEndDate () {
    return moment(this.schedule.scheduleEndDate).format("MMM DD, YYYY");
  }

  get formattedConfirmedOnDate () {
    return moment(this.schedule.userConfirmationDate).format("MMM DD, YYYY");
  }
  get dateScheduleLastModified () {
    return moment(this.schedule.dateLastModified).format("MMM DD, YYYY");
  }
  get scheduleDescription () {
    return transferScheduleUtility.getScheduleDescription(this.schedule);
  }
  get hasPreviewDates () {
    return this.schedule.upcomingDates !== undefined && this.schedule.upcomingDates.length > 0;
  }
  get previewDates () {
    return this.schedule.upcomingDates === null ? [] : this.schedule.upcomingDates;
  }
  get first10PreviewDates () {
    if (this.nowCst.hours() > 13 && this.hasClonedFromRecurringExpenseToday) {
      return this.previewDates.filter(dateStr => {
        return !this.toCstStartOfDay(dateStr).isSame(this.startOfDayTodayCst, "day");
      }).slice(0, 10);
    }
    return this.previewDates.slice(0, 10);
  }
  async copyText () {
    await navigator.clipboard.writeText(this.username);
    this.copied = true;
  }
  getPreviewDateDisplay (str) {
    return moment(str).format("dddd MMMM Do, YYYY");
  }
  get startOfDayTodayCst (): moment.Moment {
    return moment().tz("America/Chicago").startOf("day");
  }
  get nowCst (): moment.Moment {
    return moment().tz("America/Chicago");
  }
  toCstStartOfDay (date: string): moment.Moment {
    return moment.tz(date, "YYYY-MM-DD", "America/Chicago").startOf("day");
  }
  get hasClonedFromRecurringExpenseToday (): boolean {
    return this.expense &&
        this.expense.relationships &&
        this.expense.relationships.length > 0 &&
        this.expense.relationships.some(x => {
          return x.relationshipType === RelationshipType.ClonedFromRecurringTemplate &&
              x.targetExpense &&
              x.targetExpense.dateOfService &&
              this.toCstStartOfDay(x.targetExpense.dateOfService).isSame(this.startOfDayTodayCst, "day");
        });
  }
}
